import { QueryClient } from '@tanstack/react-query';

/**
 * `throwOnError: false` — mantém erros como `query.isError`, não bubbla pro
 * Suspense/ErrorBoundary do router. Sem isso, qualquer 404/500 numa query
 * sobe pro `defaultErrorComponent` e quebra a página inteira (sintoma:
 * "Something went wrong"). Components individuais já tratam `isError` com
 * fallback decente — manter isolado.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
      throwOnError: false,
    },
    mutations: {
      retry: 0,
      throwOnError: false,
    },
  },
});
